import React from "react";
import styled from "styled-components";
import { useTable, usePagination } from "react-table";
import { MdOutlineNavigateBefore, MdNavigateNext } from "react-icons/md";

const Styles = styled.div`
  table {
    border-spacing: 0;
    border: 0;
    th {
      font-weight: 600;
    }

    tbody tr:hover {
      border-left: 1px solid #6366f1;
    }
    td {
      border: 0.5px solid #f3f4f6;
      border-left: 0;
      border-right: 0;
    }

    th {
      border: 0.5px solid #f3f4f6;
      border-top-color: #f3f4f6;
    }
    th:first-child,
    td:first-child {
      border-left: 1px solid #f3f4f6;
    }
    th:last-child,
    td:last-child {
      border-right: 1px solid #f3f4f6;
    }

    th,
    td {
      width: fit-content;
      margin: 0;
      padding: 0.8rem 0.2rem;
      text-align: inherit;
      :first-child {
        padding-left: 2.5rem;
      }
    }
  }

  .pagination {
    padding-left: 2.5rem;
  }
`;

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination
  );

  // Render the UI for your table
  return (
    <>
      <div className="tbl-section overflow-x-hidden pr-10">
        <div className="overflow-x-scroll tbl-content  w-full mx-10 mt-2">
          <table {...getTableProps()} className=" bg-white mb-3 w-full">
            <thead className="bg-gray-100 font-normal">
              {headerGroups.map((headerGroup) => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="border-gray-50"
                >
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div
        className={
          pageOptions.length > 1
            ? "pagination p-0  flex flex-row-reverse"
            : "hidden"
        }
      >
        <div className="ml-auto flex">
          <button
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            className={
              canPreviousPage
                ? "flex p-2 py-1 rounded bg-blue-500 hover:bg-blue-400 text-white mr-2"
                : "flex p-2 py-1 rounded bg-gray-100 text-gray-500 mr-2 cursor-default"
            }
          >
            <span className="m-auto">First</span>
          </button>{" "}
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className={
              canPreviousPage
                ? "flex p-2 py-1 rounded bg-blue-500 hover:bg-blue-400 text-white mr-2"
                : "flex p-2 py-1 rounded bg-gray-100 text-gray-500 mr-2 cursor-default"
            }
          >
            <MdOutlineNavigateBefore className="m-auto" />
          </button>{" "}
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className={
              canNextPage
                ? "flex p-2 py-1 rounded bg-blue-500 hover:bg-blue-400 text-white mr-2"
                : "flex p-2 py-1 rounded bg-gray-100 text-gray-500 mr-2 cursor-default"
            }
          >
            <MdNavigateNext className="m-auto" />
          </button>{" "}
          <button
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
            className={
              canNextPage
                ? "flex p-2 py-1 rounded bg-blue-500 hover:bg-blue-400 text-white mr-2"
                : "flex p-2 py-1 rounded bg-gray-100 text-gray-500 mr-2 cursor-default"
            }
          >
            <span className="m-auto">Last</span>
          </button>
        </div>
        <span className="m-auto ml-0">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
      </div>
    </>
  );
}

function TableComponent(props) {
  const columns = props.columns;

  const data = props.data;

  return (
    <Styles>
      <Table columns={columns} data={data} />
    </Styles>
  );
}

export default TableComponent;
